<!--  -->
<template>
  <div class="container">
    <div class="logo-box">
        <a href="/" class="logo" title="考试系统"><img :src="`/static/images/logo.png?t=${Math.random()}`" alt="logo"></a>
         <el-button  @click="EnterPerson()" class="personcenter" round :style="`${$route.path=='/personcenter'?'background-color: rgb(255 0 0 / 50%) !important;':''}`">{{$route.path=="/personcenter"?'退出登录':user().name?user().name:'登录'}}</el-button>
    </div>
    <section class="header-menu-area">
        <div class="header-menu-fluid">
            <div class="container-fluid">
                <div class="row align-items-center estage-menu-content">
                    <div class="col-lg-12">
                        <div class="menu-wrapper">
                            <nav class="main-menu">
                                <ul>
                                    <li >
                                        <router-link to="/"><img  src="/static/images/icon_shouye2.png" class="sy">首页</router-link>
                                    </li>
                                    <div class="line_s"></div>
                                    <li>
                                        <router-link to="/papercenter"><img src="/static/images/icon_kszx.png" class="ks">考试中心</router-link>
                                    </li>
                                     <div class="line_s"></div>
                                    <li>
                                        <router-link to="/courviews"><img src="/static/images/icon_kecxi.png" class="xx">课程学习</router-link>
                                    </li>
                                     <div class="line_s"></div>
                                    <li>
                                        <router-link to="/examrecord"><img src="/static/images/icon_kaosjl.png" class="ksjl">考试记录</router-link>
                                    </li>
                                     <div class="line_s"></div>
                                    <li>
                                        <router-link to="/mistakelist"><img src="/static/images/icon_ctibn.png" class="ctb">错题本</router-link>
                                    </li>
                                     <div class="line_s"></div>
                                    <li>
                                        <router-link to="/liveview"><img src="/static/images/icon_zhibozhongxin.png" class="zb">直播中心</router-link>
                                    </li>
                                </ul><!-- end ul -->
                            </nav><!-- end main-menu -->
                        </div><!-- end menu-wrapper -->
                    </div><!-- end col-lg-9 -->
                </div><!-- end row -->
            </div><!-- end container-fluid -->
        </div><!-- end header-menu-fluid -->
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    user() {
      return this.$store.getters.user;
    },
    EnterPerson(){
        if(this.$route.path=="/personcenter"){
             localStorage.removeItem("eleTokenWrd001");
            this.$store.dispatch("clearCurrentState");
            // 页面跳转
            this.$router.push("/login");
        }
        else{
            this.$router.push("/personcenter");
        }
    },
  },
};
</script>
<style scoped>
.main-menu img {
    position: relative;
    top: -3px;
    margin-right: 8px;
}
.main-menu li {
    cursor:pointer;
}
.main-menu li:hover{
    background: linear-gradient(184deg, #C3D2F2, #F8F8F8);
}
.main-menu li a{
    width:199px;
    line-height:56px;
        display: block;
}
.main-menu li:hover a{
    color: #4182CAFF;
}
.main-menu li:hover .sy {
    content: url('/static/images/icon_shouye.png');
}
.main-menu li:hover .ks {
    content: url('/static/images/icon_kszx2.png');
}
.main-menu li:hover .xx{
    content: url('/static/images/icon_kecxi2.png');
}

.main-menu li:hover .ksjl {
    content: url('/static/images/icon_kaosjl2.png');
}
.main-menu li:hover .ctb {
    content: url('/static/images/icon_ctibn2.png');
}
.main-menu li:hover .zb {
    content: url('/static/images/icon_zhibozhongxin2.png');
}

.col-lg-12 {
    padding-right: 0px;
    padding-left: 0px;
}
</style>
